/*

ReactiveStore is a basic observable data object. Making shallow changes to
the .data property will cause the object to queue an "update" event. You can
bypass the proxy by talking to .raw, but you'll need to call schedule
() afterward. 

*/

export class ReactiveChangeEvent extends Event {
  constructor(data, changes) {
    super("update");
    this.current = data;
    this.records = changes;
  }
}

export class ReactiveStore extends EventTarget {
  scheduled = false;
  proxies = new WeakMap();
  changes = [];

  constructor(initial = {}) {
    super();
    this.notify = this.notify.bind(this);
    this.schedule = this.schedule.bind(this);
    var { schedule, proxies, changes } = this;
    var handler = {
      get(target, property, receiver) {
        var value = Reflect.get(target, property, receiver);
        switch (typeof value) {
          case "object":
            var proxy = proxies.get(value);
            if (!proxy) {
              proxy = new Proxy(value, handler);
              proxies.set(value, proxy);
            }
            return proxy;

          // trap method calls and observe them
          // would be cool to use handler.apply() but
          // it snags on Set methods
          case "function":
            return (...args) => {
              target[property](...args);
              schedule();
            };

          default:
            return value;
        }
      },
      set(target, property, value) {
        var was = target[property];
        if (value !== was) {
          target[property] = value;
          changes.push([property, was, value]);
          schedule();
        }
        return true;
      }
    }
    this.raw = initial;
    this.data = new Proxy(this.raw, handler);
  }

  schedule() {
    if (this.scheduled) return;
    this.scheduled = true;
    requestAnimationFrame(this.notify);
  }

  notify() {
    console.log(this.raw);
    // send event
    let changes = this.changes.slice();
    this.scheduled = false;
    // clear changes without altering the array reference identity
    // otherwise the handler above will store changes into the void
    this.changes.length = 0;
    this.dispatchEvent(new ReactiveChangeEvent(this.raw, changes));
  }
}